<div class="modal-header">
  <h4 class="modal-title">Late to work?</h4>
</div>
<div class="modal-body" *ngIf="viewModel$ | async as vm">
  <form [formGroup]="formGroup" class="p-1" autocomplete="off">
    <div class="row">
      <div class="col-12">
        <div class="border border-danger text-danger m-2 p-2">
          Your shift was scheduled to begin at {{ vm.startTime }}.
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group form-row">
          <label for="reason" class="col-auto col-form-label w-6rem">
            Reason
          </label>
          <div class="col-auto">
            <ng-select class="w-20rem" labelForId="reason" formControlName="reason" [items]="vm.reasons || []"
              [multiple]="false" [selectOnTab]="true" [closeOnSelect]="true" [virtualScroll]="true">
            </ng-select>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="this.logReason()">
    Submit
  </button>
</div>